var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessOutline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#289F25",
    d: "m10.954 15.134 4.954-4.953-.776-.777-4.178 4.177-2.1-2.1-.776.777zM12.001 19a6.8 6.8 0 0 1-2.73-.551 7.1 7.1 0 0 1-2.223-1.496 7.1 7.1 0 0 1-1.497-2.222A6.8 6.8 0 0 1 5 12q0-1.452.551-2.73a7.1 7.1 0 0 1 1.496-2.223A7.1 7.1 0 0 1 9.269 5.55 6.8 6.8 0 0 1 12 5q1.452 0 2.73.551a7.1 7.1 0 0 1 2.223 1.496q.945.945 1.497 2.222.55 1.278.551 2.73c.001 1.452-.184 1.878-.551 2.73a7.1 7.1 0 0 1-1.496 2.223 7.1 7.1 0 0 1-2.222 1.497A6.8 6.8 0 0 1 12 19ZM12 17.895q2.469 0 4.182-1.713T17.895 12t-1.713-4.182T12 6.105 7.818 7.818Q6.105 9.532 6.105 12t1.713 4.182Q9.532 17.895 12 17.895"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success-outline.e0bf7e54.svg";